import {Action} from 'com/gongxigames/math/core/game/enums/Action';
import {WinPresentationModule, WinPresentationPaysState} from '@gongxigames/framework/slot/modules/winpresentation';

export class WinPresentationRestoreState extends WinPresentationPaysState {
    public onEnterState(): void {
        this.module.winMeterFinished = true;
        this.view.playPayAnimation(true);
    }

    protected onReelsSpinningStarted(): void {
        this.module.stop();

        if (this.module.logic.nextAction === Action.FREESPIN) {
            this.module.stopMeter(true);
            this.module.gotoState(WinPresentationModule.FREESPINS_BASIC_STATE);
        } else {
            this.module.stopMeter(false);
            this.module.gotoState(WinPresentationModule.BASIC_STATE);
        }
    }
}
